import moment from 'moment'

import {
    IBooking,
    IManagement,
    ILocation,
    TBookingService,
} from './store/types'
import { normalizeBookingLocationFromApi } from './bookingSaveHelpers'

export const formatBookingApiDate = (value?: Date | string | null): string =>
    moment(value ?? undefined).format('YYYY-MM-DD')

/** Management slot is no longer an active booking (cancelled / declined). */
export const isManagementSlotCancelled = (status?: string): boolean => {
    if (!status) {
        return false
    }
    const normalized = status.toLowerCase()
    return (
        normalized === 'cancelled' ||
        normalized === 'canceled' ||
        normalized === 'declined'
    )
}

export const minBookingServiceDurationMinutes = (
    services?: TBookingService[],
    fallback = 30,
): number => {
    if (!services?.length) {
        return fallback
    }
    const minutes = services
        .map(item => item.hours * 60 + item.minutes)
        .filter(item => item > 0)
    if (!minutes.length) {
        return fallback
    }
    return Math.min(...minutes)
}

export const normalizeBookingFromApi = (booking: IBooking): IBooking => ({
    ...booking,
    schedule: booking.schedule ?? [],
    services: booking.services ?? undefined,
    location: booking.location
        ? normalizeBookingLocationFromApi(
              booking.location as ILocation & { imageUrl?: string },
          )
        : booking.location,
})

export const normalizeManagementFromApi = (
    data: IManagement & { location?: ILocation | string | null },
): IManagement => {
    let location: ILocation
    if (typeof data.location === 'string') {
        location = {
            id: '',
            name: data.location,
            address: '',
            description: '',
            photoUrl: '',
        }
    } else if (data.location) {
        location = normalizeBookingLocationFromApi(
            data.location as ILocation & { imageUrl?: string },
        )
    } else {
        location = {
            id: '',
            name: '',
            address: '',
            description: '',
            photoUrl: '',
        }
    }

    const schedule = (data.schedule ?? []).map(row => ({
        ...row,
        employeeId: row.employeeId ?? row.employeeViewModel?.id ?? '',
    }))

    return { location, schedule }
}
